export default __webpack_public_path__ + "assets/media/sunglasses.e99b3a93.png";